import { createMatchSelector } from 'react-router-redux';

export const selectTokenAndUserIdFromRoute = (state) => {
  const selector = createMatchSelector({ path: '/forgot-password/:userId?/:token?' })(
    state,
  );
  if (typeof selector !== 'object' || selector === null) return {};
  const {
    params: { token, userId },
  } = selector;
  return { token, userId };
};



// WEBPACK FOOTER //
// ./redux/selectors/router.js